import { Controller, useFormContext } from 'react-hook-form'

import { sarPrimaryFederalRegulators } from 'commons/types/dictionaries'
import { FF2, Select, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const FederalRegulator = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`institutionActivitiesInfo.${index as 0}.federalRegulator`}
      control={control}
      rules={{
        validate: Validators.required.field
      }}
      render={({ field }) => (
        <FF2
          required
          field={field}
          label="52. Primary federal regulator"
          input={(props) => (
            <Select
              {...props}
              data={sarPrimaryFederalRegulators}
              data-qa="52. Primary federal regulator"
              options-data-qa="52. Primary federal regulator option"
            />
          )}
        />
      )}
    />
  )
}
